<app-modal-frame [headerText]="CONSTS.HEADER" [hasHeaderCloseButton]="false">
  <ion-grid class="exit-modal-container">
    <ion-row>
      <ion-col class="body">
        {{ CONSTS.BODY }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="buttons">
        <ion-button
          expand="block"
          fill="outline"
          class="reject-button"
          (click)="onClose(buttonClick.REJECT)"
        >
          {{ CONSTS.REJECT_TEXT }}
        </ion-button>
        <ion-button
          expand="block"
          fill="solid"
          class="confirm-button"
          (click)="onClose(buttonClick.ACCEPT)"
        >
          {{ CONSTS.CONFIRM_TEXT }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</app-modal-frame>
